import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { KindAllNodeStoreContext } from '../contexts/StoreContext'
import { KindAllNodeStore } from '../store/interface'

export const useKindAllNodeStore = <M extends boolean, StateSlice>(
  selector: (store: KindAllNodeStore<M>) => StateSlice
) => {
  return useContextStore<KindAllNodeStore<M>, StateSlice>(
    KindAllNodeStoreContext as any,
    selector
  )
}

export const useKindAllNodeStoreApi = <M extends boolean>() => {
  return useContextStoreApi<KindAllNodeStore<M>>(KindAllNodeStoreContext as any)
}
